(function () {
  'use strict';

  function initDesktopNavigation() {
    var navigations = document.querySelectorAll(
      '.bedz-global-nav:not(.bedz-global-nav--compact)'
    );

    if (!navigations.length) {
      return;
    }

    Array.prototype.forEach.call(navigations, function (navigation) {
      var disclosures = Array.prototype.slice.call(
        navigation.querySelectorAll('.bedz-global-nav__disclosure')
      );

      function closeAll(exceptDisclosure) {
        disclosures.forEach(function (disclosure) {
          if (disclosure !== exceptDisclosure) {
            disclosure.removeAttribute('open');
          }
        });
      }

      disclosures.forEach(function (disclosure) {
        disclosure.addEventListener('toggle', function () {
          if (disclosure.open) {
            closeAll(disclosure);
          }
        });
      });

      document.addEventListener('click', function (event) {
        if (!navigation.contains(event.target)) {
          closeAll();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') {
          return;
        }

        var openDisclosure = navigation.querySelector(
          '.bedz-global-nav__disclosure[open]'
        );

        if (!openDisclosure) {
          return;
        }

        var trigger = openDisclosure.querySelector(
          '.bedz-global-nav__trigger'
        );

        openDisclosure.removeAttribute('open');

        if (trigger) {
          trigger.focus();
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initDesktopNavigation
    );
  } else {
    initDesktopNavigation();
  }
})();